// Display styles constants
export const DEFAULT = 'DEFAULT';
export const COMPACT = 'COMPACT';
